import { ExternalLink } from "lucide-react";
import { useOperator } from "@/context/OperatorContext";

// Link to a Morr Access owner page (team, emails, contacts, business, plans, apps). Hidden when not available.
export function MorrLink({ to, label, testId, className = "" }) {
  const { operator } = useOperator() || {};
  const href = operator?.morr_links?.[to];
  if (!href) return null;
  return (
    <a href={href} data-testid={testId}
      className={`inline-flex items-center gap-1.5 border border-border bg-background px-3 h-8 text-xs font-medium hover:bg-secondary transition-colors ${className}`}>
      {label} <ExternalLink className="h-3.5 w-3.5" />
    </a>
  );
}
